import { createEntitySlice } from '@/shared/store/createEntitySlice';
import { dsAgentsApi } from '../api';
import type { DSAgent, DSAgentFilters, DSAgentFormData } from '../types';

export const DS_AGENTS_DEFAULT_FILTERS: DSAgentFilters = {
  search: '',
  dateRange: null,
  email: '',
  firstName: '',
  lastName: '',
  isEnabled: '',
};

const initialState = {
  items: [] as DSAgent[],
  loading: false,
  error: null as string | null,
  currentPage: 1,
  perPage: 10,
  total: 0,
  lastPage: 1,
  filters: DS_AGENTS_DEFAULT_FILTERS,
};

const { actions, reducer } = createEntitySlice<DSAgent, DSAgentFilters, DSAgentFormData>({
  name: 'dsAgentsEntity',
  api: dsAgentsApi,
  initialState,
  getListParams: (state) => {
    const { currentPage, perPage, filters } = state.dsAgentsEntity;
    const params: Record<string, unknown> = { page: currentPage, perPage };

    if (filters.search && filters.search.trim()) {
      params.search = filters.search.trim();
    }

    if (filters.email && filters.email.trim()) {
      params.email = filters.email.trim();
    }

    if (filters.firstName && filters.firstName.trim()) {
      params.firstName = filters.firstName.trim();
    }

    if (filters.lastName && filters.lastName.trim()) {
      params.lastName = filters.lastName.trim();
    }

    if (filters.isEnabled !== '') {
      params.isEnabled = filters.isEnabled;
    }

    return params;
  },
});

export const {
  fetchItems: fetchDSAgents,
  createItem: createDSAgent,
  updateItem: updateDSAgent,
  deleteItem: deleteDSAgent,
  setPage,
  setPerPage,
  setFilters,
} = actions;

export { reducer };
